<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <TitleWidget>
      {{ title }}
    </TitleWidget>

    <LoadingWidget v-if="loading" />

    <template v-else>
      <template v-if="items.length">
        <div class="mt-6 mt-md-8 items">
          <EventCard
            v-for="(item, keyItems) in items"
            :key="keyItems"
            v-bind="item"
          />
        </div>

        <v-pagination
          class="mt-6"
          v-if="items.length && pagesLength"
          v-model="page"
          :length="pagesLength"
          :total-visible="6"
          flat
        ></v-pagination>
      </template>

      <v-alert v-else type="info">
        {{ noContentText }}
      </v-alert>
    </template>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import EventCard from "../components/cards/EventCard.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "events",
  path: "/eventos",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  title: "Eventos",
  loading: true,
  totalItems: 0,
  noContentText: "Nenhum evento adicionada até o momento",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title, text }) => ({
        img,
        title,
        text,
        to: `${_config.path}/${formatToURL(`${title}-${id}`)}`,
      }));
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    query() {
      return this.$route.query;
    },
    page: {
      get() {
        const p = this.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.p = v;
        else delete query.p;

        this.$router.push({ path: _config.path, query });
      },
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        returnTotalItems: _pagination.returnTotalItems,
        itemsPerPage: _pagination.itemsPerPage,
        page: this.page,
      };

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, data) => {
            if (_pagination.returnTotalItems) {
              this.totalItems = data.totalItems;
              state.list = data.list;
            } else state.list = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    LoadingWidget,
    EventCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  display: grid;
  gap: 56px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 959.9px) {
    gap: 20px 12px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
